import React from 'react'
import { Modal } from 'react-bootstrap/lib'

const DeleteHiveModal = ({ deleteReport, report = {}, show, display }) => (
    <Modal show={ show } onHide={ display }>
        <Modal.Header closeButton={ true }>
            <Modal.Title>Supprimer un rapport.</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className='row'>
                <div className='col-md-12'>
                   Êtes vous certain de vouloir supprimer <strong>ce rapport</strong>?
                    <div className='well m-t-12 m-b-4'>
                        { report && report.hive && `${report.visitNumber} - ${report.hive.identifier} - ${report.client.name}` }
                    </div> 
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <a className='btn btn-default' onClick={ display }>
                Annuler
            </a>
            <button name='submit-login' type='submit' className='btn btn-danger' onClick={ report && deleteReport.bind(null, report._id) }>
                Supprimer
            </button>
        </Modal.Footer>
    </Modal>
)

export default DeleteHiveModal


// WEBPACK FOOTER //
// ./src/client/features/reports/components/DeleteReportModal.jsx